export const API_URL = "https://some-data.onrender.com/stores";
